<template>
<section id="benefits" class="vpn-section privacy">
  <div class="vpn-section__inner privacy__inner">
    <div class="privacy__copy">
      <h2>{{ privacyTitle }}</h2>
      <p v-if="privacyLeadFull" class="privacy__lead">{{ privacyLeadFull }}</p>
      <p v-else class="privacy__lead">
        <router-link to="/">Secure VPN</router-link>
        helps you create a safer and more private online experience. Enjoy encrypted connections, secure browsing, and better protection wherever you access the internet.
      </p>

      <div class="privacy__subtitle">{{ privacySubtitle }}</div>
      <ul class="privacy__list">
        <li v-for="item in benefitList" :key="item.title">
          <span class="privacy__check" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="14" height="14">
              <path fill="currentColor" d="M9.6 16.2 5.9 12.5l1.4-1.4 2.3 2.3 6.9-6.9 1.4 1.4z" />
            </svg>
          </span>
          <div>
            <strong>{{ item.title }}</strong>
            <p>{{ item.desc }}</p>
          </div>
        </li>
      </ul>
    </div>

    <div class="privacy__media">
      <img
        src="@/assets/vpn/privacy.webp"
        alt="Protect your privacy with Secure VPN"
        loading="lazy"
        width="827"
        height="825"
      >
    </div>
  </div>
</section>
</template>

<script>
import homeLocaleContent from '@/mixins/homeLocaleContent';

export default {
  name: 'PrivacySection',
  mixins: [homeLocaleContent],
  computed: {
    privacyTitle() {
      return this.homeLocale?.privacyTitle || 'Protect Your Privacy with a Free VPN';
    },
    privacyLeadFull() {
      return this.homeLocale?.privacyLead || '';
    },
    privacySubtitle() {
      return this.homeLocale?.privacySubtitle || 'Key Benefits';
    },
    benefitList() {
      return this.homeLocale?.privacyBenefits || this.defaultBenefits;
    },
  },
  data() {
    return {
      defaultBenefits: [
        {
          title: 'No Data or Speed Limits',
          desc: 'Browse, stream, and connect freely without restrictions on your VPN usage.',
        },
        {
          title: 'No Ads',
          desc: 'Enjoy a clean and uninterrupted VPN experience without annoying advertisements.',
        },
        {
          title: 'No Activity Logs',
          desc: 'Your online activity stays private with a no-log approach designed to protect your personal information.',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/vpn-sections.scss';

.privacy {
  background: #fff;
}

.privacy__inner {
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  gap: 56px;
  align-items: center;
}

.privacy__copy {
  h2 {
    margin: 0 0 32px;
    font-size: clamp(26px, 3.2vw, 36px);
    color: var(--vpn-ink, #1f2430);
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: -0.02em;
  }
}

.privacy__lead {
  margin: -16px 0 32px;
  color: var(--vpn-ink-muted, #5b6475);
  font-size: 16px;
  line-height: 1.6;
  max-width: 500px;

  a {
    color: #6d4aff;
    font-weight: 600;
    text-decoration: none;
  }
}

.privacy__subtitle {
  margin: 0 0 16px;
  font-size: 18px;
  color: #37296b;
  font-weight: 700;
}

.privacy__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 18px;
}

.privacy__list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.privacy__check {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #eef0f4;
  color: #8b93a7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.privacy__list strong {
  display: block;
  margin-bottom: 4px;
  color: #1f2430;
  font-size: 16px;
  font-weight: 700;
}

.privacy__list p {
  margin: 0;
  color: #6b7280;
  font-size: 15px;
  line-height: 1.55;
}

.privacy__media {
  position: relative;
  display: flex;
  justify-content: center;

  img {
    width: 100%;
    max-width: 520px;
    height: auto;
    display: block;
  }
}

@media (max-width: 900px) {
  .privacy__inner {
    grid-template-columns: 1fr;
    gap: 22px;
  }

  .privacy__media {
    order: -1;

    img {
      max-width: min(360px, 100%);
    }
  }

  .privacy__lead {
    max-width: none;
    font-size: 15px;
  }
}

@media (max-width: 560px) {
  .privacy__media img {
    max-width: 100%;
  }
}
</style>
